/*───────────────────────────────────────────────────────────────
 📄 File: components/webrtc/WebRTCIncomingScreen.tsx
 🧩 Description:
    Incoming ringing call screen with answer / decline buttons.
    Extracted from WebRTCPhonePanel.tsx.
────────────────────────────────────────────────────────────────*/

import { Phone, PhoneIncoming, PhoneOff } from 'lucide-react';

interface CallInfo { remoteName?: string | null; remoteNumber?: string | null; }

interface Props {
    callInfo: CallInfo | null;
    onAnswer: () => void;
    onReject: () => void;
}

export function WebRTCIncomingScreen({ callInfo, onAnswer, onReject }: Props) {
    return (
        <div className="flex-1 flex flex-col">
            <div className="flex-1 flex flex-col items-center justify-center">
                <PhoneIncoming className="w-12 h-12 text-green-400 mb-4 animate-pulse" />
                <div className="text-xl font-semibold text-foreground mb-1">
                    {callInfo?.remoteName || callInfo?.remoteNumber || 'Unknown'}
                </div>
                {callInfo?.remoteName && callInfo?.remoteNumber && (
                    <div className="text-sm text-muted-foreground mb-4">{callInfo.remoteNumber}</div>
                )}
                <div className="text-sm text-muted-foreground">Incoming Call...</div>
            </div>
            <div className="grid grid-cols-2 gap-3">
                <button onClick={onReject} className="py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center justify-center gap-2">
                    <PhoneOff className="w-5 h-5" /> Decline
                </button>
                <button onClick={onAnswer} className="py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg flex items-center justify-center gap-2">
                    <Phone className="w-5 h-5" /> Answer
                </button>
            </div>
        </div>
    );
}
